import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section id="about" className="section">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="section-head">
            <span className="section-path">about</span>
            <h2>About me</h2>
          </div>

          <div className="about-content">
            <div className="about-image">
              <img src="/images/NEW_Image.png" alt="Qazi Absaar" />
              <div className="image-decoration"></div>
            </div>
            
            <div className="about-text">
              <p>
                I am a passionate and skilled professional with expertise in artificial intelligence 
                (machine learning, deep learning, computer vision) and the Internet of Things (IoT). 
                My focus is on developing smart, efficient, and scalable tech solutions.
              </p>
              <p className="about-location">
                <strong>Location:</strong> Islamabad, Pakistan
              </p>
              <p>
                I have hands-on experience building intelligent systems, backend APIs, and real-time 
                communication interfaces using technologies like ESP32, Jetson Orin, and Arduino. 
                Currently in my 7th semester of a Computer Science B.S. at Pak-Austria Fachhochschule,
                I am specializing in cybersecurity, AI, embedded systems, and computer vision.
              </p>

              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-number">4+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">15+</div>
                  <div className="stat-label">Projects Completed</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">5+</div>
                  <div className="stat-label">Certifications</div>
                </div>
              </div>
            </div>


          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
